module.exports = __webpack_public_path__ + "img/ai1.4e5c3a3e.png";